var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowsExchange({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "arrows-exchange",
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.392,
    height: 16.253,
    viewBox: "0 0 22.392 16.253",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M9.383,25.968a1.4,1.4,0,0,0-.742,2.584L12.4,32.31a1.4,1.4,0,0,0,1.977-1.978l-1.567-1.566H23.364a1.4,1.4,0,1,0,0-2.8H9.383Z",
    transform: "translate(-7.984 -16.466)",
    fill: "#00828b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M31.393,19.126a1.4,1.4,0,0,0,.742-2.584l-3.758-3.758A1.4,1.4,0,0,0,26.4,14.762l1.567,1.566H17.412a1.4,1.4,0,0,0,0,2.8H31.393Z",
    transform: "translate(-10.401 -12.375)",
    fill: "#00828b"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowsExchange);
export default __webpack_public_path__ + "static/media/arrows-exchange.9c634872b956a9b887ee42aaa07faf99.svg";
export { ForwardRef as ReactComponent };